"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var berry = {
  50: '#ffebed',
  100: '#fdbbc4',
  200: '#f88e9d',
  300: '#f2667c',
  400: '#e84763',
  500: '#db2f51',
  600: '#ca1e45',
  700: '#b5133d',
  800: '#9c0c37',
  900: '#820831',
  A100: '#fff5f6',
  A200: '#eb6476',
  A400: '#ee283f',
  A700: '#b60d1b'
};
exports["default"] = berry;